import React from 'react';
import getAllPrecautionNotification from './getAllPrecautionNotification.graphql';

import { injectIntl } from 'react-intl';
import messages from '../../../../locale/messages';

import PrecautionNotificationForm from '../../../../components/SiteAdmin/PrecautionNotificationForm/PrecautionNotificationForm';
import Loader from '../../../../components/Common/Loader/Loader';
import useQueryResponse from '../../../../lib/hooks/useQueryResponse';

const PrecautionNotificationPage = ({ intl: { formatMessage } }) => {

  const { loading, data } = useQueryResponse({
    query: getAllPrecautionNotification,
    fetchPolicy: 'network-only',
    variables: {},
  });

  let initialValues = { isEnabled: 'true' };

  if (
    !loading &&
    data?.getAllPrecautionNotification?.results?.length > 0
  ) {
    const firstResult = data.getAllPrecautionNotification.results[0];
    initialValues = {
      ...firstResult,
      isEnabled: firstResult.isEnabled ? 'true' : 'false',
    };
  }

  return (
    <Loader type="page" show={loading}>
      <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.precautionNotification)}</h1>
      {!loading && <PrecautionNotificationForm initialValues={initialValues} />}
    </Loader>
  );
};

export default injectIntl(PrecautionNotificationPage);
